import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';
import messages from '../../text/messages';
import Tabs from '../../components/tabs';
import CompanyInformation from './forms/companyInformation';
import Billing from './forms/billing';
import ProgramPolicies from './forms/programPolicies';

import './company.css';

class CompanyPage extends React.Component {
    render() {
        const steps = [
            { title: <FormattedMessage {...messages.companyInformation} />, content: <CompanyInformation /> },
            { title: <FormattedMessage {...messages.companyBillingAndAch} />, content: <Billing /> },
            { title: <FormattedMessage {...messages.companyProgramPolicies} />, content: <ProgramPolicies /> }
        ];
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12 company-page">
                        <Tabs items={steps} pageWide title={CompanyPage.meta.label} isPageTitle={true} />
                    </div>
                </div>
            </div>
        );
    }
}

CompanyPage.meta = {
    label: <FormattedMessage id={'company'} defaultMessage={'Company'} />,
    icon: 'business',
    action: () => history.push('/company'),
    locations: ['/company']
};

export default CompanyPage;



// WEBPACK FOOTER //
// ./src/pages/company/index.jsx